import { render } from "./WalletView.vue?vue&type=template&id=2b557874&scoped=true"
import script from "./WalletView.vue?vue&type=script&lang=js"
export * from "./WalletView.vue?vue&type=script&lang=js"

import "./WalletView.vue?vue&type=style&index=0&id=2b557874&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b557874"]])

export default __exports__